// src/questions/dueDiligenceQuestions.js

// Master-lista för DD-underlag (dokument/bilagor).
// Används av DueDiligencePortal -> DueDiligenceUploadSection.
//
// NEW (schema rewrite):
// - each question includes a canonical dataroom folderPath so frontend can display where uploads belong
// - folderKey is a stable string for backend mapping/auto-creation
//
// folderPath format (simple v1):
//   [bucket, sectionTitle, qid]
// Example:
//   ["03_Contracts", "AVTAL OCH ÅTAGANDEN", "10.3"]

export const DDQ_SECTIONS = [
  {
    id: 1,
    title: "BOLAGSHANDLINGAR",
    bucket: "01_Corporate",
    items: [
      q("1.1", "Aktiebok", true),
      q("1.2", "Aktiebrev (både fram och baksida)", true),
      q(
        "1.3",
        "Eventuella ändringsanmälningar till Bolagsverket som inte registrerats",
        true
      ),
      q("1.4", "Bolagsordning", true),
      q("1.5", "Samtliga bolagsstämmoprotokoll de senaste fem åren", true),
      q("1.6", "Samtliga styrelseprotokoll de senaste fem åren", true),
      q(
        "1.7",
        "Aktieägaravtal där Bolaget är part eller som avser aktierna",
        true
      ),
      q(
        "1.8",
        "Villkorade/ovillkorade aktieägartillskott, konvertibler, teckningsoptioner m.m.",
        true
      ),
      q(
        "1.9",
        "Handlingar om panträtt/säkerhetsrätt i aktier samt förköps-/hembuds-/samtyckesvillkor",
        true
      ),
      q(
        "1.10",
        "Förteckning över fullmakter + kopia av samtliga fullmakter",
        true
      ),
      q(
        "1.11",
        "Uppgifter om dotterbolag/ägda andelar och handlingar enligt 1.1–1.11 för dessa",
        true
      ),
    ],
  },
  {
    id: 2,
    title: "INFORMATION OM BOLAGETS STYRELSE",
    bucket: "01_Corporate",
    items: [
      q(
        "2.1",
        "Förteckning över styrelseledamöter, ledande befattningshavare och revisor inkl. aktie-/instrumentinnehav och ersättningar",
        true
      ),
      q("2.2", "Kopior av avtal för medlemmarna av Bolagets styrelse", true),
      q("2.3", "Ersättningshandlingar för styrelsemedlemmar", true),
    ],
  },
  {
    id: 3,
    title: "INFORMATION OM BOLAGETS ANSTÄLLDA",
    bucket: "04_HR",
    items: [
      q(
        "3.1",
        "Organisationsschema inkl. ledande befattningar och antal anställda",
        true
      ),
      q(
        "3.2",
        "Samtliga anställningsavtal + lista över samtliga anställda med villkor (lön, semester, uppsägningstid, pension, tjänstebil, förmåner)",
        true
      ),
      q("3.3", "Åtaganden om IP, sekretess och konkurrensbegränsning", true),
      q(
        "3.4",
        "Tillämpliga kollektivavtal och medlemskap i arbetsgivarorganisation",
        true
      ),
      q(
        "3.5",
        "Bonus-/vinstdelningsprogram, optionsprogram, avgångsvederlag",
        true
      ),
      q(
        "3.6",
        "Försäkringar, sjukvård och övriga förmåner samt andra villkor",
        true
      ),
      q(
        "3.7",
        "Personalhandböcker/policys inkl. arbetsmiljö, jämställdhet, GDPR-info, utbildningar och personalomsättning",
        true
      ),
      q("3.8", "Pensionsplaner och pensionsutfästelser", true),
      q(
        "3.9",
        "Hur pensionsrättigheter tryggas (försäkring, skuldföring, stiftelse)",
        true
      ),
      q(
        "3.10",
        "Verksamhetsförändringar som påverkat personal de senaste två åren",
        true
      ),
      q(
        "3.11",
        "Avtal med nuvarande/före detta anställda, styrelse m.fl. inkl. lån och garantier",
        true
      ),
      q("3.12", "Avtal med konsulter och bemanningsföretag", true),
      q(
        "3.13",
        "Inspektioner/förelägganden från Arbetsmiljöinspektionen m.fl.",
        true
      ),
    ],
  },
  {
    id: 4,
    title: "ÅRSREDOVISNINGAR M.M.",
    bucket: "02_Financial",
    items: [
      q(
        "4.1",
        "Årsredovisningar/delårsrapporter/koncernredovisning senaste fem åren",
        true
      ),
      q(
        "4.2",
        "Bevis om att årsredovisning givits in i rätt tid senaste fem åren",
        true
      ),
      q(
        "4.3",
        "Delårsrapporter för de tre senaste räkenskapsåren",
        true
      ),
      q(
        "4.4",
        "Samtliga revisionspromemorior och korrespondens med revisor",
        true
      ),
    ],
  },
  {
    id: 5,
    title: "IMMATERIELLA RÄTTIGHETER",
    bucket: "05_IP",
    items: [
      q(
        "5.1",
        "IP-portfölj (patent, varumärken, upphovsrätt, mönster, domäner) inkl. registreringsbevis, ansökningar och förnyelser",
        true
      ),
      q(
        "5.2",
        "Medgivanden lämnade för annans registrering av varumärke/firma",
        true
      ),
      q(
        "5.3",
        "Avtal för nyttjande av annans IP/know-how (licenser m.m.)",
        true
      ),
      q("5.4", "Avtal om upplåtelse av Bolagets IP/know-how", true),
      q(
        "5.5",
        "Avtal om pantsättning av IP och myndighetsbekräftelser om registrering",
        true
      ),
    ],
  },
  {
    id: 6,
    title: "SKATT",
    bucket: "02_Financial",
    items: [
      q(
        "6.1",
        "Information om skatterevisioner och skatteprocesser (pågående/avslutade)",
        true
      ),
    ],
  },
  {
    id: 7,
    title: "FINANSIELLA ARRANGEMANG",
    bucket: "02_Financial",
    items: [
      q(
        "7.1",
        "Förteckning över bank-/PlusGirokonton och behöriga",
        true
      ),
      q(
        "7.2",
        "Låne-/leasing-/hyres-/avbetalningsavtal, factoring, säkerheter, skulder",
        true
      ),
      q("7.3", "Factoring/förskott och liknande arrangemang", true),
      q(
        "7.4",
        "Tillgänglig finansiering och outnyttjade kreditramar",
        true
      ),
      q("7.5", "Pantsättningar och företagshypotek (ej under 7.2)", true),
      q("7.6", "Borgensförbindelser, garantier och liknande åtaganden", true),
      q(
        "7.7",
        "Bidrag/understöd/lån från myndigheter senaste tre åren",
        true
      ),
    ],
  },
  {
    id: 8,
    title: "VIKTIGA AFFÄRSHÄNDELSER (12 MÅN)",
    bucket: "01_Corporate",
    items: [
      q(
        "8.1",
        "Omständigheter med väsentlig inverkan (avbrott, inriktning m.m.)",
        true
      ),
      q("8.2", "Väsentliga förpliktelser", true),
      q("8.3", "Väsentliga utgifter och kapitalutfästelser", true),
      q(
        "8.4",
        "Engångsföreteelser som påverkar intäkter/utgifter",
        true
      ),
      q("8.5", "Väsentliga osäkra fordringar", true),
      q(
        "8.6",
        "Väsentliga förändringar i lån (villkor, belopp, kreditgivare)",
        true
      ),
    ],
  },
  {
    id: 9,
    title: "MARKNAD M.M.",
    bucket: "01_Corporate",
    items: [
      q("9.1", "Produktbroschyrer", true),
      q("9.2", "Nuvarande/tidigare produkter", true),
      q("9.3", "Prisnivå och priskänslighet", true),
      q("9.4", "Produktcertifieringar", true),
      q("9.5", "Produktgarantier", true),
      q("9.6", "Marknadsmaterial", true),
      q(
        "9.7",
        "Reklamationer/klagomål från viktiga kunder/större belopp",
        true
      ),
      q("9.8", "Distributionskanaler", true),
      q("9.9", "Försäljningsvolymer och marknadsandelar", true),
    ],
  },
  {
    id: 10,
    title: "AVTAL OCH ÅTAGANDEN",
    bucket: "03_Contracts",
    items: [
      q("10.1", "Ägar-/HB-/JV-/samarbetsavtal", true),
      q(
        "10.2",
        "Agent/återförsäljare/distribution/provision > 100 tkr eller väsentliga",
        true
      ),
      q(
        "10.3",
        "Tio största kunder: lista, årsomsättning 5 år, avtal, sedvänjor",
        true
      ),
      q(
        "10.4",
        "Tio största leverantörer: lista, årsomsättning 5 år, avtal, sedvänjor",
        true
      ),
      q(
        "10.5",
        "Avtal med närstående (styrelse, ägare, ledning m.fl.)",
        true
      ),
      q(
        "10.6",
        "Styrelse/anställdas innehav i Bolaget eller närstående",
        true
      ),
      q("10.7", "Koncerninterna låne-/andra avtal", true),
    ],
  },
  {
    id: 11,
    title: "ANDRA AVTAL",
    bucket: "03_Contracts",
    items: [
      q("11.1", "Allmänna villkor/standardavtal (bransch/bolag)", true),
      q("11.2", "Leasingavtal", true),
      q("11.3", "Factoring (fakturabelåning)", true),
      q(
        "11.4",
        "Långtids-/stora avtal (> 1 år eller > 100 tkr)",
        true
      ),
      q(
        "11.5",
        "Icke-marknadsmässiga eller betungande villkor",
        true
      ),
      q("11.6", "Change of control / uppsägningsklausuler m.m.", true),
    ],
  },
  {
    id: 12,
    title: "FÖRSÄKRINGAR",
    bucket: "02_Financial",
    items: [
      q(
        "12.1",
        "Försäkringsskydd och försäkringsbrev (inkl. nyckelpersoner)",
        true
      ),
      q(
        "12.2",
        "Försäkringskrav > 10 000 kr senaste fem åren",
        true
      ),
      q(
        "12.3",
        "Omständigheter som kan påverka försäkringsskyddet",
        true
      ),
    ],
  },
  {
    id: 13,
    title: "TVISTER",
    bucket: "01_Corporate",
    items: [
      q(
        "13.1",
        "Pågående/hotande tvister, skiljeförfaranden, medling m.m.",
        true
      ),
      q(
        "13.2",
        "Avslutade rättsprocesser senaste fyra åren",
        true
      ),
      q("13.3", "Dokumentation för tvister och ombud", true),
    ],
  },
  {
    id: 14,
    title: "MYNDIGHETSTILLSTÅND M.M.",
    bucket: "01_Corporate",
    items: [
      q(
        "14.1",
        "Tillstånd, certifieringar, godkännanden, koncessioner och anmälningar",
        true
      ),
    ],
  },
  {
    id: 15,
    title: "FAST EGENDOM",
    bucket: "01_Corporate",
    items: [
      q(
        "15.1",
        "Förteckning över fastigheter (läge, pris, bokfört värde, taxeringsvärde)",
        true
      ),
      q(
        "15.2",
        "Avtal om förvärv/försäljning av fastigheter",
        true
      ),
      q("15.3", "Pantbrev: kopior/placering/pantsättning", true),
      q("15.4", "Kartor/planer/bygglov m.m.", true),
      q(
        "15.5",
        "Lagfarter, inskränkningar, hyresavtal, hembud, driftstillstånd, inteckningar/servitut/kvarstad m.m.",
        true
      ),
      q("15.6", "Tomträttsavtal", true),
      q(
        "15.7",
        "Hyrd/nyttjanderätt: hyresavtal, uppsägningar, hyresjusteringar, viktiga villkor, hembud m.m.",
        true
      ),
    ],
  },
  {
    id: 16,
    title: "IT",
    bucket: "05_IP",
    items: [
      q(
        "16.1",
        "Beskrivning av IT-miljö (tjänster, mjukvara, hårdvara)",
        true
      ),
      q(
        "16.2",
        "Väsentliga IT-avtal (>30 tkr): licenser, utveckling, HW-köp/hyra, konsult, support/underhåll, outsourcing, hosting, escrow, DR, koncerninterna",
        true
      ),
      q(
        "16.3",
        "Delning av resurser med andra bolag och villkor för detta",
        true
      ),
      q(
        "16.4",
        "Lista över standardapplikationer: arbetsstationer, licenser köpta/använda",
        true
      ),
      q("16.5", "Pågående IT-projekt och villkor", true),
      q(
        "16.6",
        "IT-utgifter senaste räkenskapsåret (licenser, tjänster, HW, appar)",
        true
      ),
      q(
        "16.7",
        "Översikt av egenutvecklad mjukvara och vem som utvecklat den",
        true
      ),
      q("16.8", "Lista över databaser och syften", true),
      q(
        "16.9",
        "Behandling av personuppgifter (kategorier, typer, syften, säkerhet, tredjeland)",
        true
      ),
      q(
        "16.10",
        "IT-säkerhetsstrategi (policy, identitetskontroll, brandväggar, infrastruktur)",
        true
      ),
    ],
  },
  {
    id: 17,
    title: "KONKURRENSFÖRHÅLLANDEN",
    bucket: "03_Contracts",
    items: [
      q(
        "17.1",
        "Avtal med kunder som begränsar kommersiell frihet/konkurrens",
        true
      ),
      q(
        "17.2",
        "Avtal med leverantörer som begränsar kommersiell frihet/konkurrens",
        true
      ),
    ],
  },
  {
    id: 18,
    title: "ÖVRIGT",
    bucket: "01_Corporate",
    items: [
      q(
        "18.1",
        "Rapporter/utredningar (juridik/finans/teknik) sista tre åren",
        true
      ),
      q(
        "18.2",
        "Prospekt, erbjudandeskrifter, informationsmemorandum senaste tre åren",
        true
      ),
      q(
        "18.3",
        "Övriga omständigheter som kan påverka Bolaget negativt",
        true
      ),
    ],
  },
];

// Helper: injects folderPath + folderKey
function q(qid, text, requiresUpload = false) {
  const section = String(qid).split(".")[0]; // "10.3" -> "10"
  // folderPath is finalized later in attachMeta() because we need section title + bucket
  return {
    qid,
    text,
    requiresUpload,
    // filled by attachMeta()
    folderPath: null,
    folderKey: null,
    sectionId: Number(section) || null,
  };
}

// Attach derived folderPath/folderKey using section metadata
(function attachMeta() {
  for (const sec of DDQ_SECTIONS) {
    const bucket = sec.bucket || null;
    for (const item of sec.items) {
      if (!item.requiresUpload) continue;

      // Simple v1 rule: [bucket, sectionTitle, qid]
      const folderPath = [bucket, sec.title, item.qid].filter(Boolean);
      item.folderPath = folderPath;
      item.folderKey = folderPath.join("/");
    }
  }
})();
